import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export const RollupWarningMessage = ({
  tableName
}) => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "reporting-snowflake.metadata-warnings.dangerous-rollup-property_jsx",
    elements: {
      Link
    },
    options: {
      external: true,
      tableName,
      href: 'https://knowledge.hubspot.com/reports/understand-the-custom-report-builder#rollup-fields'
    }
  });
};